import React, { memo } from 'react'

import Box from '@material-ui/core/Box'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'

import Highlighter from 'react-highlight-words'

const formatTime = (seconds: number) => {
    const format = (val: number) => `0${Math.floor(val)}`.slice(-2)

    const hours = seconds / 3600
    const minutes = (seconds % 3600) / 60
    const secs = seconds % 60

    return [...(hours >= 1 ? [hours] : []), minutes, secs].map(format).join(':')
}
const useStyles = makeStyles({
    chip: {
        fontSize: '12px',
        marginRight: '4px',
        cursor: 'pointer',
        color: '#CB0000',
        fontWeight: 500
    },
    text: {
        fontSize: '12px',
        fontWeight: 500
    },
    subtitleBackground: {
        borderRadius: '4px',
        border: ({
            isActive,
            searchWords
        }: {
            isActive: boolean
            searchWords: string[]
        }) =>
            isActive && !searchWords[0]?.trim()?.length
                ? 'solid #FED443 1px'
                : 'none',
        background: ({
            isActive,
            searchWords
        }: {
            isActive: boolean
            searchWords: string[]
        }) =>
            isActive && !searchWords[0]?.trim()?.length
                ? '#FAFAFA'
                : 'transparent'
    }
})

export type HighlightedSegmentProps = {
    /**
     * object with data
     */
    searchWords?: string[]
    subtitle: {
        duration: number
        start: number
        text: string
    }
    /**
     * used to highlight the component
     */
    isActive: boolean
    /**
     * on segment click handler
     */
    onClick: () => void
}

export const HighlightedSegment = memo(
    ({
        subtitle,
        isActive,
        onClick,
        searchWords = []
    }: HighlightedSegmentProps) => {
        const classes = useStyles({ isActive, searchWords })

        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="start"
                px={1}
                style={{ cursor: 'pointer' }}
                className={classes.subtitleBackground}
                onClick={onClick}
            >
                <Box
                    display="flex"
                    justifyContent="space-between"
                    style={{ width: '100%' }}
                >
                    <Box ml={1} p={1}>
                        <Highlighter
                            highlightStyle={{
                                backgroundColor: '#FFF2C7'
                            }}
                            searchWords={searchWords}
                            textToHighlight={subtitle?.text}
                            className={classes.text}
                        />
                    </Box>
                </Box>
                <Typography className={classes.chip}>
                    {formatTime(subtitle.start)}
                </Typography>
            </Box>
        )
    }
)
